import { render } from "./adopt-case.vue?vue&type=template&id=f06222be&scoped=true"
import script from "./adopt-case.vue?vue&type=script&lang=js"
export * from "./adopt-case.vue?vue&type=script&lang=js"

import "./adopt-case.vue?vue&type=style&index=0&id=f06222be&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06222be"]])

export default __exports__